module.exports = __webpack_public_path__ + "img/u30912.fa201abd.png";